import { ReactNode } from 'react';
import { MatchType, PartnerGroupRules, useGroupRules, UserGroupRules } from 'src/graphql';

interface AuthorizationProps {
  forbiddenFallback?: ReactNode;
  children: ReactNode;
  allowedRules?: (PartnerGroupRules | UserGroupRules)[];
  matchType?: MatchType;
}

export const AuthorizedContent = ({
  allowedRules,
  forbiddenFallback = null,
  children,
  matchType = 'any',
}: AuthorizationProps) => {
  const { checkValidity, loading } = useGroupRules();

  let canAccess = true;

  if (allowedRules) {
    canAccess = checkValidity(allowedRules, { matchType });
  }

  const shouldRender = canAccess && !loading;

  return shouldRender ? children : forbiddenFallback;
};
